/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CheckDuplicatedMediaListNameResponseAllOf,
    CheckDuplicatedMediaListNameResponseAllOfFromJSON,
    CheckDuplicatedMediaListNameResponseAllOfFromJSONTyped,
    CheckDuplicatedMediaListNameResponseAllOfToJSON,
} from './CheckDuplicatedMediaListNameResponseAllOf';
import {
    MediaListApiResponse,
    MediaListApiResponseFromJSON,
    MediaListApiResponseFromJSONTyped,
    MediaListApiResponseToJSON,
} from './MediaListApiResponse';

/**
 * 
 * @export
 * @interface CheckDuplicatedMediaListNameResponse
 */
export interface CheckDuplicatedMediaListNameResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof CheckDuplicatedMediaListNameResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof CheckDuplicatedMediaListNameResponse
     */
    message: string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckDuplicatedMediaListNameResponse
     */
    isDuplicated: boolean;
}

export function CheckDuplicatedMediaListNameResponseFromJSON(json: any): CheckDuplicatedMediaListNameResponse {
    return CheckDuplicatedMediaListNameResponseFromJSONTyped(json, false);
}

export function CheckDuplicatedMediaListNameResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckDuplicatedMediaListNameResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'isDuplicated': json['is_duplicated'],
    };
}

export function CheckDuplicatedMediaListNameResponseToJSON(value?: CheckDuplicatedMediaListNameResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'is_duplicated': value.isDuplicated,
    };
}

